import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function SymbolTileChartHelp() {
    return (
        <IconTooltip>
            <div>
                The Price Capsule details price movements of a selected symbol.{' '}
                <br /> <br />
                To configure, select a symbol from your portfolio or enter a
                symbol in settings. <br /> <br />
                You can also view precise values for Current Price, Bid and Ask,
                Previous Night&apos;s Close, High, and Low, for the selected
                symbol by “flipping” the capsule (click on the Capsule).
                <br /> <br />
                The price line plots the close price of a bucket. The
                &ldquo;High&ldquo; and &ldquo;Low&ldquo; blobs represent the
                highest and lowest prices for all buckets.
            </div>
        </IconTooltip>
    );
}
